// extracted by mini-css-extract-plugin
export var bg = "template-module--bg--014b3";
export var contentModal = "template-module--contentModal--225e2";
export var contentWrap = "template-module--contentWrap--78c4d";
export var formDetails = "template-module--form-details--e4fd1";
export var formTitle = "template-module--formTitle--d983d";
export var pageDescription = "template-module--pageDescription--eca9d";
export var promocontainer = "template-module--promocontainer--69b5d";
export var reviews = "template-module--reviews--c5784";
export var successModal = "template-module--successModal--73079";
export var terms = "template-module--terms--1b765";